<template>
  <div class="ticket-table-card">
    <div class="table-title">{{$t('deviceOpen.jiaofuziyuan')}}</div>

      <el-table :data="ticketInfoTable"
              style="width: 100%"
              max-height="300">
                        <!-- 序号 -->
                        <el-table-column width="50"

                                        :label="this.$t('alarmHistory.index')">
                          <template slot-scope="scope">
                            <span>{{scope.$index + 1}}</span>
                          </template>
                        </el-table-column>
                        <!-- 设备类型 -->
                        <el-table-column prop="deviceType "
                        width="100"
                                        :label="this.$t('equipment.equipmentType')">
                          <template slot-scope="scope">
                            <span>{{scope.row.deviceType  | maybeEmpty}}</span>
                          </template>
                        </el-table-column>
                         <!-- 产品名称 -->
                        <el-table-column prop="productName "
                        width="150"
                                        :label="this.$t('cabinetReservation.productName')">
                          <template slot-scope="scope">
                            <span>{{scope.row.productName  | maybeEmpty}}</span>
                          </template>
                        </el-table-column>
                          <!-- 产品规格 -->
                          <el-table-column key="productSpec"

                                        min-width="200"
                                          :label="$t('deviceOpen.chanpinguige')">
                            <template slot-scope="scope">
                              <span>{{scope.row.productSpec | maybeEmpty}}</span>
                            </template>
                          </el-table-column>
                          <!-- 数量 -->
                          <el-table-column key="quantity"
                          width="100"
                                          :label="$t('GeneralServices.count')">
                            <template slot-scope="scope">
                             <span>{{scope.row.quantity}}</span>
                            </template>
                          </el-table-column>

                        </el-table>

  </div>
</template>
<script>
import {
  cloneDeep
} from 'lodash';

export default {
  name: 'GeneralServicesTable',
  props: {
    // info
    ticketInfoTable: {
      type: Array,
      default () { return null; },
    },
    ticketTemplateCode: {
      type: String,
      default: ''
    },
  },
  computed: {
    ticketInfoTableCopy () {
      return cloneDeep(this.ticketInfo);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-title {
  height: 40px;
  line-height: 40px;
  background-color: #f3f7fb;
  border: 1px solid #d9e1e9;
  font-size: 13px;
  border-bottom: none;
  padding-left: 8px;
}
.ticket-table-card {
  margin: 10px 0 20px 0;
}
a.auto-break {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/workSheet/common/ResourceTable.vue